import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'NuxtLinkCustom',
  props: {
    to: null
  },
  setup: function setup(__props) {
    var props = __props;

    /**
     *  Renders a NuxtLink component with fallback behavior if the `to` prop is not provided until we pass to Nuxt3.
     *  If `to` is defined, it behaves like a normal NuxtLink.
     *  If `to` is not defined, it redirects to the homepage with a `translation_error` parameter for tracking.
     */

    var route = useRoute();

    /**
     * Computed property that returns the `to` URL for the NuxtLink.
     * If the `to` prop is provided, it uses the given value.
     * Otherwise, it defaults to the homepage (`/`) and appends a query parameter to track missing links.
     *
     * @returns {string} The destination URL for the link.
     */

    var computedTo = computed(function () {
      if (props.to) {
        return props.to;
      }
      if (process.client && route.fullPath) {
        var errorUrl = "/?translation_error=".concat(encodeURIComponent(route.fullPath));
        return errorUrl;
      }
      return '/';
    });
    return {
      __sfc: true,
      props: props,
      route: route,
      computedTo: computedTo
    };
  }
});